import React from "react";

export default function MobileCard4() {

    const AllItems = [{
  title :"Batch A — Science",
  teacher : "Mr. Rajesh Kumar",
  start : "10:00 AM",
  end : "12:00 PM",
  days : ["Mon", "Wed", "Fri"],
  room : "Room 204",
  type : "Offline"
},{
  subject : "Physics",
  topic : "Newton’s Laws of Motion",
  teacher :"Mr. R. Deshmukh",
  date : "Today",
  time : "2:00 PM – 3:00 PM",
  type : "Live",
}]
  return (<>{AllItems?.map((i,index)=>(
<>{i?.type=="Offline"?<><div className="batch-card">
      <div className="batch-header">
        <h3>{i?.title}</h3>
        <span className="batch-type">{i?.type}</span>
      </div>
 <div className="categories-row">
        {["IBPS PO", "NABARD Grade A", "SBI Clerk", "Banking"].map(
          (c, i) => (
            <div className="category-chip" key={i}>
              {c}
            </div>
          )
        )}
      </div>
      <div className="batch-section">
        <p className="label">Teacher</p>
        <p className="value">{i?.teacher}</p>
      </div>

      <div className="batch-grid">
        <div>
          <p className="label">Start</p>
          <p className="value">{i?.start}</p>
        </div>

        <div>
          <p className="label">End</p>
          <p className="value">{i?.end}</p>
        </div>

        <div>
          <p className="label">Days</p>
          <div className="days-row">
            {i?.days.map((d, i) => (
              <span key={i}>{d}</span>
            ))}
          </div>
        </div>

        <div>
          <p className="label">Room</p>
          <p className="value">{i?.room}</p>
        </div>
      </div>

      <button className="join-btn">Join Class</button>
    </div></>:i?.type=="Live"?<> <div className="upcoming-card">
      <div className="upcoming-header">
        <span className="upcoming-type">{i?.type}</span>
      </div>

      <h3 className="upcoming-subject">{i?.subject}</h3>
      <p className="upcoming-topic">{i?.topic}</p>

      <div className="upcoming-info">
        <div>
          <p className="label">Teacher</p>
          <p className="value">{i?.teacher}</p>
        </div>

        <div>
          <p className="label">Date</p>
          <p className="value">{i?.date}</p>
        </div>

        <div>
          <p className="label">Time</p>
          <p className="value">{i?.time}</p>
        </div>
      </div>

      <button className="start-btn">Start Class</button>
    </div></>:""}
</>
  ))}
    
   
    <style>{`.batch-card {
  background: #101218;
  border: 1px solid #1a1f2b;
  border-radius: 16px;
  padding: 18px;
  margin: 10px 0;
  box-shadow: 0 4px 16px rgba(0,0,0,0.35);
  color: #e9eef6;
  font-family: system-ui, sans-serif;
}

/* Header */
.batch-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.batch-header h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
}

.batch-type {
  background: #6aa2ff;
  color: #000;
  padding: 4px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
}

/* Teacher Section */
.batch-section {
  margin-bottom: 16px;
}

.label {
  font-size: 12px;
  color: #a6b0c2;
  margin: 0 0 2px;
}

.value {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}

/* Grid */
.batch-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 20px;
}

/* Days row */
.days-row {
  display: flex;
  gap: 8px;
}

.days-row span {
  padding: 4px 8px;
  font-size: 12px;
  background: #121622;
  border: 1px solid #1a1f2b;
  border-radius: 8px;
}

/* CTA Button */
.join-btn {
  width: 100%;
  padding: 12px;
  background: #6aa2ff;
  color: #000;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.join-btn:active {
  transform: scale(0.97);
}.upcoming-card {
  background: #101218;
  border: 1px solid #1a1f2b;
  border-radius: 16px;
  padding: 18px;
  margin: 14px 0;
  box-shadow: 0 4px 16px rgba(0,0,0,0.35);
  color: #e9eef6;
  font-family: system-ui, sans-serif;
}

/* Type badge */
.upcoming-header {
  display: flex;
  justify-content: flex-end;
}

.upcoming-type {
  background: #ffcb47;
  color: #000;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
}

/* Subject */
.upcoming-subject {
  margin: 10px 0 4px;
  font-size: 18px;
  font-weight: 600;
}

/* Topic */
.upcoming-topic {
  margin: 0 0 16px;
  font-size: 14px;
  color: #a6b0c2;
}

/* Info rows */
.upcoming-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 20px;
}

.label {
  font-size: 12px;
  color: #a6b0c2;
  margin: 0 0 2px;
}

.value {
  margin: 0;
  font-size: 14px;
}

/* CTA */
.start-btn {
  width: 100%;
  padding: 12px;
  background: #6aa2ff;
  color: #000;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.start-btn:active {
  transform: scale(0.97);
}
/* Categories chips */
.categories-row {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 6px;
}
.categories-row::-webkit-scrollbar {
  display: none;
}
.category-chip {
  background: #121622;
  border: 1px solid #1a1f2b;
  padding: 8px 14px;
  border-radius: 20px;
  font-size: 13px;
  white-space: nowrap;
  cursor: pointer;
}

.category-chip:active {
  background: #6aa2ff;
  color: #000;
}

`}</style>
    </>
  );
}
